import React from 'react'
import { Form as RsForm, Row, Col, Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { Input } from 'components/inputs'
import { Select } from 'components/select'
import { grapeType } from 'enums/grapeType'
import { useStyles } from './form.css'

const Form = (props) => {
  const classes = useStyles()
  
  const { disabled, data, updateEntity, localize } = props
  const { entity } = data
  if (!entity) { return null }
  return (
    <RsForm>
      <Row className={classes.row}>
        <Col sm='6'>
          <Label>{localize('common.name')}</Label>
          <Validator name='name' value={entity.name} required maxLength={255} disabled={disabled}>
            <Input value={entity.name} onChange={updateEntity('name')} placeholder={localize('common.name')} disabled={disabled} />
          </Validator>
        </Col>
        <Col sm='6'>
          <Label>{localize('grapes.tag')}</Label>
          <Validator name='tag' value={entity.tag} required min={0} disabled={disabled}>
            <Select value={entity.tag} onChange={updateEntity('tag')}
              placeholder={localize('grapes.tag')} disabled={disabled}
              enum={grapeType} />
          </Validator>
        </Col>
      </Row>
    </RsForm>
  )
}

export default Form